// Brand colors for LIGHT-background artifacts that must carry the EsuSol /
// ControlPilot identity: the transactional HTML emails AND the FHA member-record
// certificate PDF. These artifacts stay LIGHT (email deliverability; print-friendly
// paper) even though the app itself is dark-themed — the identity comes through the
// navy header bar and the gold accents.
//
// This module is the ONE place to change these values — keep in sync with the theme
// tokens in src/index.css / tailwind.config.js. Email markup must use literal hex
// (clients strip CSS vars/classes); jsPDF likewise needs literal hex.

// Canonical brand tokens (mirror the app palette).
const BRAND_CORE = {
  navy:     '#0F172A', // ControlPilot navy — brand surface / header bar (neutral-50)
  gold:     '#F59E0B', // ControlPilot gold — primary accent / CTA (primary-600 / warning-500)
  paleGold: '#FCD34D', // pale gold — subtitle text on the navy header
  white:    '#ffffff',
  success:  '#22C55E', // success-500 — "Confirmed"
  warning:  '#F59E0B', // warning-500 — "Pending" (same hue as gold)
};

// Light-surface tokens (shared by emails + the certificate).
const LIGHT_SURFACE = {
  pageBg:      '#f9fafb', // page background (kept light on purpose)
  surface:     '#ffffff', // card / paper surface
  border:      '#e5e7eb', // light gray — borders / table rules
  heading:     '#111827', // near-black — headings / emphasized cell text
  muted:       '#6b7280', // gray — body / label / date text
  footnote:    '#9ca3af', // gray — fine print
  tableBg:     '#f3f4f6', // light gray — table background
  tableStripe: '#e9eaec', // table stripe
};

// Canonical set consumed by the certificate PDF (downloadMemberRecordPdf).
export const BRAND_LIGHT = { ...BRAND_CORE, ...LIGHT_SURFACE };

// Email templates keep their existing key names, now sourced from the canonical
// tokens above so emails + certificate never drift (values are unchanged).
export const EMAIL_COLORS = {
  pageBg:      LIGHT_SURFACE.pageBg,
  surface:     LIGHT_SURFACE.surface,
  border:      LIGHT_SURFACE.border,
  brand:       BRAND_CORE.navy,     // navy header bar
  brandSubtle: BRAND_CORE.paleGold, // subtitle on navy header
  onBrand:     BRAND_CORE.white,    // text on the navy header
  button:      BRAND_CORE.gold,     // primary CTA button
  onButton:    BRAND_CORE.navy,     // text on the gold CTA
  heading:     LIGHT_SURFACE.heading,
  muted:       LIGHT_SURFACE.muted,
  footnote:    LIGHT_SURFACE.footnote,
  tableBg:     LIGHT_SURFACE.tableBg,
  tableStripe: LIGHT_SURFACE.tableStripe,
};
